import React from 'react';
import { HexColorInput, HexAlphaColorPicker } from 'react-colorful';
import getFonts from '../../../Functions/config/fonts';
import getSelectField from '../../fields/select';
import toggleColorPicker from '../../../Functions/toggleColorPicker';

const ResultsDisplay = ({ widget, handleInputChange, setColorsAndPreview }) => {
    const { affordability } = widget.htmlData;
    const fontFamilyOptions = getFonts().map(font => ({ value: font, label: font }));

    return (
        <div className="mjwi-acc-panel-wrapper">
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Background Color</label>
                </div>
                <div className="mjwi-col66 mjwi-clr-picker">
                    <span
                        className="clrPickerVal"
                        style={{ backgroundColor: affordability.results.bgColor }}
                        onClick={toggleColorPicker}
                    ></span>
                    <HexAlphaColorPicker
                        color={affordability.results.bgColor}
                        onChange={(color) => setColorsAndPreview('results', 'bgColor', color)}
                        style={{ display: 'none' }}
                        className="mjwi-apfl-color-picker"
                    />
                    <HexColorInput
                        color={affordability.results.bgColor}
                        onChange={(color) => setColorsAndPreview('results', 'bgColor', color)}
                    />
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Text Color</label>
                </div>
                <div className="mjwi-col66 mjwi-clr-picker">
                    <span
                        className="clrPickerVal"
                        style={{ backgroundColor: affordability.results.textColor }}
                        onClick={toggleColorPicker}
                    ></span>
                    <HexAlphaColorPicker
                        color={affordability.results.textColor}
                        onChange={(color) => setColorsAndPreview('results', 'textColor', color)}
                        style={{ display: 'none' }}
                        className="mjwi-apfl-color-picker"
                    />
                    <HexColorInput
                        color={affordability.results.textColor}
                        onChange={(color) => setColorsAndPreview('results', 'textColor', color)}
                    />
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Border Color</label>
                </div>
                <div className="mjwi-col66 mjwi-clr-picker">
                    <span
                        className="clrPickerVal"
                        style={{ backgroundColor: affordability.results.borderColor }}
                        onClick={toggleColorPicker}
                    ></span>
                    <HexAlphaColorPicker
                        color={affordability.results.borderColor}
                        onChange={(color) => setColorsAndPreview('results', 'borderColor', color)}
                        style={{ display: 'none' }}
                        className="mjwi-apfl-color-picker"
                    />
                    <HexColorInput
                        color={affordability.results.borderColor}
                        onChange={(color) => setColorsAndPreview('results', 'borderColor', color)}
                    />
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Font Family</label>
                </div>
                <div className="mjwi-col50">
                    {getSelectField('fontFamily', fontFamilyOptions.map(opt => opt.label), affordability.results.fontFamily || 'Arial, sans-serif', (e) => handleInputChange(e, ['results']))}
                </div>
            </div>
        </div>
    );
};

export default ResultsDisplay;